class ViewerLockImplementation {
    constructor() {
        this._lock_id = Symbol('ViewerLockSystem');
    }
}
export class ViewerLockSystem {
    constructor() {
        this._active_locks = new Set();
    }
    acquire_lock() {
        const lock = new ViewerLockImplementation();
        this._active_locks.add(lock._lock_id);
        return lock;
    }
    release_lock(lock) {
        if (!this._active_locks.has(lock._lock_id)) {
            throw new Error('Invalid lock');
        }
        this._active_locks.delete(lock._lock_id);
    }
    is_locked() {
        return this._active_locks.size > 0;
    }
}
//# sourceMappingURL=LockSystem.js.map